import { render, staticRenderFns } from "./BaseCheckboxV3.vue?vue&type=template&id=186f4e94"
import script from "./BaseCheckboxV3.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxV3.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckboxV3.vue?vue&type=style&index=0&id=186f4e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports